/**
 * テンプレートサイト（請求書・見積書などフリーランス書類）の URL。環境ごとに違う。
 * .env.staging は末尾スラッシュ付き、.env.production は無しで不揃いなので、
 * `//?customToken=` にならないよう末尾スラッシュを落として持つ。
 */
export const templateAppUrl = (
  process.env.VUE_APP_TEMPLATE_APP_URL || ''
).replace(/\/+$/, '')
